import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'

/**
 * 場所選択マップ、アドレスエリア
 */
const AddressArea: React.FC<AddressAreaProps> = (props) => {
  return (
    <StyledAddressArea>
      {props.addressComponent}
      <Text>
        {props.addressInfo
          ? props.addressInfo
          : props.locationName
          ? `【${props.locationName}】\n${props.address}`
          : props.address}
      </Text>
    </StyledAddressArea>
  )
}

export type AddressAreaProps = {
  locationName: string
  address: string
  addressComponent: React.ReactNode
  addressInfo: string
}

const StyledAddressArea = styled.div`
  position: relative;
  display: flex;
  flex-wrap: no-wrap;
  align-items: center;
  padding: 8px 12px;
  background: var(--color-content-background);
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 -4px 5px -1px rgba(0, 0, 0, 0.2);

  > * {
    margin: 0 4px;
  }
`

export default React.memo<AddressAreaProps>(AddressArea)
